import React, { Component } from 'react';
import { func, node, string } from 'prop-types';
import classNames from 'classnames';

import css from './OutsideClickHandler.module.css';

export default class OutsideClickHandler extends Component {
  constructor(props) {
    super(props);

    this._touchHandled = false;
    this.handleClick = this.handleClick.bind(this);
    this.handleTouch = this.handleTouch.bind(this);
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClick, false);
    document.addEventListener('touchstart', this.handleTouch, { passive: true });
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClick, false);
    document.removeEventListener('touchstart', this.handleTouch);
  }

  handleTouch(event) {
    this._touchHandled = true;
    // Reset flag so a subsequent mousedown from the same gesture is ignored
    setTimeout(() => { this._touchHandled = false; }, 500);
    if (!this.node.contains(event.target)) {
      this.props.onOutsideClick();
    }
  }

  handleClick(event) {
    // Skip if already handled by a touch event in the same gesture
    if (this._touchHandled) return;
    if (!this.node.contains(event.target)) {
      this.props.onOutsideClick();
    }
  }

  render() {
    const { rootClassName, className, children } = this.props;
    const classes = classNames(rootClassName || css.root, className);

    return (
      <div className={classes} ref={node => (this.node = node)}>
        {children}
      </div>
    );
  }
}

OutsideClickHandler.defaultProps = {
  rootClassName: null,
  className: null,
};

OutsideClickHandler.propTypes = {
  rootClassName: string,
  className: string,
  onOutsideClick: func.isRequired,
  children: node.isRequired,
};
